import React, {useEffect, useState} from "react";
import {TouchableOpacity} from "react-native";
import {TranslationView} from "@levelapp/softfabric-ui";
import LanguageToggleView from "./components/languagetoggle/LanguageToggleView";
import LoginButtonView from "../loginbutton/LoginButtonView";
import LogOutButtonView from "../logoutbutton/LogOutButtonView";
import MyProfileButtonView from "../myprofilebutton/MyProfileButtonView";
import {getToken} from "../../../../../../../Common/Utils/token.utils";

interface MenuItemsViewProps {
    menuItemStyle: any;
    isVisible: boolean;
}

export default function MenuItemsView({menuItemStyle, isVisible}: MenuItemsViewProps) {

    const [token, setToken] = useState<string|undefined>(getToken());

    useEffect(() => {
        setToken(getToken());
    }, [getToken, token]);

    const divStyle = {
        marginBottom: isVisible ? 0 : 15,
        marginTop: isVisible ? 0 : 15,
        marginRight: isVisible ? 15 : 0
    };

    return (
        <>
            <TouchableOpacity style={divStyle}>
                <a href='https://www.beebonds.com' style={{textDecoration: 'none', textAlign: 'center'}} target='_blank' rel="noopener noreferrer">
                    <TranslationView style={menuItemStyle}>home</TranslationView>
                </a>
            </TouchableOpacity>
            <TouchableOpacity style={divStyle}>
                <a href='https://www.beebonds.com/projets' style={{textDecoration: 'none', textAlign: 'center'}} target='_blank' rel="noopener noreferrer">
                    <TranslationView style={menuItemStyle}>projects</TranslationView>
                </a>
            </TouchableOpacity>
            <TouchableOpacity style={divStyle}>
                <a href='https://www.beebonds.com/contact' style={{textDecoration: 'none', textAlign: 'center'}} target='_blank' rel="noopener noreferrer">
                    <TranslationView style={menuItemStyle}>contact</TranslationView>
                </a>
            </TouchableOpacity>
            <LanguageToggleView menuItemStyle={menuItemStyle} divStyle={divStyle} isVisible={isVisible}/>
            {token !== undefined ? (
                <>
                    <MyProfileButtonView isVisible={isVisible} divStyle={divStyle}/>
                    <LogOutButtonView isVisible={isVisible} divStyle={divStyle} setToken={setToken}/>
                </>
            ) : (
                <LoginButtonView isVisible={isVisible} divStyle={divStyle} setToken={setToken}/>
            )}
        </>
    );
}